import zIndex from "@mui/material/styles/zIndex";
import React,{useState} from "react";
import { useNavigate } from "react-router-dom";
import logger from "../utils/logger";


export default function RegisterForm() {
    const [email, setEmail]=useState('')
    const [username, setUsername]= useState('');
    const [password, setPassword]= useState('');

    const navigate=useNavigate();


    const handleSendEmail= async() => {
        const payload={email, username, password};

        try {
            const res=await fetch("",{
                method:"post",
                headers:{"Content-Type":"application/json"},
                body:JSON.stringify(payload),
            });

            if(res.ok){
                alert("Email sent to support");

            } else {
                alert("Failed to send email");
            }
        } catch (err){
            logger.error("Error")
        }

    };

    const containerStyle={
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)',
        padding:'30px',
        width:'500px',
        zIndex:1000,
        backgroundColor:'#f5f5f5',

    };

    const boxStyle={
        padding:'10px',
        backgroundColor:'#fff',
        borderRadius:'12px',
        boxShadow:'0 0 15px rgba(0,0,0,0.2)',
        width:'100%',
    };

    return (
        <div style={containerStyle}>
            <div style={boxStyle}>
            <h2> Register </h2>
            <input 
                type="email"
                placeholder="Email"
                value={email}
                onChange ={(e)=>setEmail(e.target.value)}
                className="w-full p-2 border rounded"
            />
            <input 
                type="text"
                placeholder="Create your username"
                value={username}
                onChange ={(e)=>setUsername(e.target.value)}
                className="w-full p-2 border rounded"
            />
            <input 
                type="password"
                placeholder="Create your password"
                value={password}
                onChange ={(e)=>setPassword(e.target.value)}
                className="w-full p-2 border rounded"
            />
            <button
                onClick={handleSendEmail}
                className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"

            >
                Please contact support for your request
            </button>
            </div>
        </div>
    );
}